webpackJsonp([1],{

/***/ "/xwR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2H6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FaNk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GlE0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DiscordLogo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DiscordLogo = ({
  //TODO: add animationStyle and angry/wink discord logo via JavaScript! (define a root element, get ID from there)
  name: 'DiscordLogo',
  props: {
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    },
    customLink: {
      type: String,
      default: ''
    },
    animationStyle: {
      type: String,
      default: 'swirl' //swirl rotateX rotateY shake softshake
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    },
    background: {
      type: String,
      default: 'none'
    }
  },
  data: function data() {
    return {
      discordFaceID: null,
      canvasID: null,
      canvas: '',
      ctx: '',
      frames: 0,
      RAF: null
    };
  },

  watch: {
    animationStyle: function animationStyle() {
      this.updateAnimation();
    },
    discordEyes: function discordEyes() {
      this.updateEyes();
    },
    background: function background() {
      this.wireUpCanvas();
    }
  },
  mounted: function mounted() {
    this.discordFaceID = "discordFaceID" + this._uid;
    this.wireUpCanvas();
  },

  created: function created() {
    this.update();
  },
  methods: {
    update: function update() {
      this.updateAnimation();
      this.updateEyes();
    },
    updateAnimation: function updateAnimation() {
      this.$nextTick(function () {
        var svgns = "http://www.w3.org/2000/svg";
        var xlinkns = "http://www.w3.org/1999/xlink";
        var discordLogoRootElement = this.$refs.discordLogoRootElement;
        var discordLogo = discordLogoRootElement.getElementsByClassName("discord-logo")[0];
        while (discordLogo.firstChild) {
          discordLogo.removeChild(discordLogo.firstChild);
        }
        discordLogo.setAttribute("class", "discord-logo " + this.animationStyle + "-animation");
        var useElement = document.createElementNS(svgns, "use");
        useElement.setAttribute("class", "discord-original");
        useElement.setAttributeNS(xlinkns, "href", "#" + this.discordFaceID);
        discordLogo.appendChild(useElement);
        if (this.animationStyle == "swirl") {
          ["inner", "middle", "outer"].map(function (item) {
            var useElement = document.createElementNS(svgns, "use");
            useElement.setAttribute("class", "discord-" + item + "-layer");
            useElement.setAttributeNS(xlinkns, "href", "#" + this.discordFaceID);
            useElement.setAttribute("mask", "url(#mask-" + item + "-layer)");
            discordLogo.appendChild(useElement);
          }, this);
        }
      });
    },
    updateEyes: function updateEyes() {
      this.$nextTick(function () {
        var svgns = "http://www.w3.org/2000/svg";
        var xlinkns = "http://www.w3.org/1999/xlink";
        var discordLogoRootElement = this.$refs.discordLogoRootElement;
        var discordEyesSVG = discordLogoRootElement.getElementsByClassName("discord-eyes")[0];
        while (discordEyesSVG.firstChild) {
          discordEyesSVG.removeChild(discordEyesSVG.firstChild);
        }
        if (this.discordEyes == "angry") {
          var useElement = document.createElementNS(svgns, "use");
          useElement.setAttributeNS(xlinkns, "href", "#discord-def-face-eyes");
          useElement.setAttribute("mask", "url(#mask-eyes-angry)");
          discordEyesSVG.appendChild(useElement);
        } else if (this.discordEyes == "wink") {
          var useElement = document.createElementNS(svgns, "use");
          useElement.setAttributeNS(xlinkns, "href", "#discord-def-face-left-eye");
          discordEyesSVG.appendChild(useElement);
          var useElement = document.createElementNS(svgns, "use");
          useElement.setAttributeNS(xlinkns, "href", "#discord-def-face-right-eye");
          useElement.setAttribute("mask", "url(#mask-right-eye-wink)");
          discordEyesSVG.appendChild(useElement);
        } else if (this.discordEyes == "none") {
          var useElement = document.createElementNS(svgns, "use");
          useElement.setAttributeNS(xlinkns, "href", "#discord-def-face-eyes");
          discordEyesSVG.appendChild(useElement);
        } else if (this.discordEyes == "noeyes") {}
      });
    },
    wireUpCanvas: function wireUpCanvas() {
      if (this.background !== 'none') {
        this.canvasID = "canvasID" + this._uid;
        this.$nextTick(function () {
          this.canvas = this.$refs[this.canvasID];
          this.ctx = this.canvas.getContext('2d');
          if (this.RAF !== null) cancelAnimationFrame(this.RAF);
          this.draw();
        });
      }
    },
    draw: function draw() {
      var _this = this;

      var t = this.frames / 200;
      var s = void 0,
          i = void 0,
          X = void 0,
          Z = 0,
          j = void 0,
          p = void 0,
          w = void 0,
          W = void 0,
          V = void 0;
      var r = function r(q) {
        return _this.ctx[q ? "lineTo" : "moveTo"](w + (X - 7) / Z * w * 2, 2 / Z * w);
      };
      switch (this.background) {
        case 'starfield':
          this.canvas.style.width = "50px";
          this.canvas.style.height = "50px";
          this.canvas.width = 250;
          this.canvas.height = 250;
          this.ctx.fillStyle = "#fffa";
          for (var _j = 250, _w = 100; _j--;) {
            Z = 1 - (_j * _j / _w + this.frames / 100) % 1;
            s = 1 + Math.pow(3 * (1 - Z), 2);
            this.ctx.beginPath();
            this.ctx.arc(_w + (99 - _j % 199) / Z, 100 + (99 - _j * _j * 7 % 198) / Z, s, 0, 7);
            this.ctx.fill();
          }
          break;
        case 'grid':
          this.canvas.style.width = "50px";
          this.canvas.style.height = "50px";
          this.canvas.width = 250;
          this.canvas.height = 250;
          this.ctx.strokeStyle = "#fff4";
          w = 120, i = 200, t = this.frames / 70, X = 0;
          for (; i--; this.ctx.lineWidth = 0.5 + 8 / (1 + Z), r(Z++), r(X--), this.ctx.stroke()) {
            this.ctx.beginPath(), X = (i + Math.sin(t) * 4) % 14, Z = 1 + (i / 14 | 0) - t * 5 % 1, r();
          }break;
        case 'rush':
          this.canvas.style.width = "50px";
          this.canvas.style.height = "50px";
          this.canvas.width = 250;
          this.canvas.height = 250;
          this.ctx.fillStyle = "#fff3";
          W = 120, j = 10, p = 0, V = 0, s = 0;
          for (; --j;) {
            for (var _i = 16; _i--; this.ctx.fillRect(W + Math.sin(p = .39 * _i + j / 8 - 6.03 * V - Math.sin(t * 2) * 3) / Z * W - s / 2, 120 + Math.cos(p) / Z * W - s / 2, s, s)) {
              Z = .5 + j / 2 - t * 6 + (V = t * 6 | 0), s = 200 / (1 + Z) / (1 + Z) / (1 + Z);
            }
          }break;
      }
      this.frames++;
      this.RAF = requestAnimationFrame(this.draw);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea7e53cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiscordLogo.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"discordLogoRootElement",staticClass:"discord-logo-container",attrs:{"color":_vm.discordcolor,"fill":_vm.discordfill,"width":_vm.width,"height":_vm.height,"viewBox":"0 0 48 48"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"currentfill"}}),_vm._v(" "),(_vm.background !== 'none')?_c('foreignObject',{staticStyle:{"width":"100%","height":"100%"}},[_c('body',{attrs:{"xmlns":"http://www.w3.org/1999/xhtml"}},[_c('canvas',{ref:_vm.canvasID,attrs:{"id":"discordCanvas"}})])]):_vm._e(),_vm._v(" "),_c('defs',[_c('g',[_c('defs',[_c('path',{attrs:{"id":"discord-def-face","fill":"currentcolor","d":"M40,12C40,12,35.415,8.412,30,8L29.512,8.976C34.408,10.174,36.654,11.891,39,14C34.955,11.935,30.961,10,24,10S13.045,11.935,9,14C11.346,11.891,14.018,9.985,18.488,8.976L18,8C12.319,8.537,8,12,8,12S2.879,19.425,2,34C7.162,39.953,15,40,15,40L16.639,37.815C13.857,36.848,10.715,35.121,8,32C11.238,34.45,16.125,37,24,37S36.762,34.45,40,32C37.285,35.121,34.143,36.848,31.361,37.815L33,40C33,40,40.838,39.953,46,34C45.121,19.425,40,12,40,12Z"}}),_vm._v(" "),_c('g',{attrs:{"id":"discord-def-face-eyes"}},[_c('path',{attrs:{"id":"discord-def-face-left-eye","fill":"currentfill","d":"M17.5,30C15.567,30,14,28.209,14,26C14,23.791,15.567,22,17.5,22S21,23.791,21,26C21,28.209,19.433,30,17.5,30Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"discord-def-face-right-eye","fill":"currentfill","d":"M30.5,30C28.567,30,27,28.209,27,26C27,23.791,28.567,22,30.5,22S34,23.791,34,26C34,28.209,32.433,30,30.5,30Z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":_vm.discordFaceID}},[_c('use',{attrs:{"href":"#discord-def-face"}}),_vm._v(" "),_c('g',{attrs:{"id":"discord-logo-eyes"}},[_c('mask',{attrs:{"id":"mask-right-eye-wink"}},[_c('ellipse',{attrs:{"fill":"#FFFFFF","ry":"15","rx":"15","cy":"39.7","cx":"35"}}),_vm._v(" "),_c('ellipse',{attrs:{"fill":"#000000","ry":"15","rx":"15","cy":"40.5","cx":"34"}})]),_vm._v(" "),_c('mask',{attrs:{"id":"mask-eyes-angry"}},[_c('rect',{attrs:{"height":"48","width":"48","y":"0","x":"0","fill":"#FFFFFF"}}),_vm._v(" "),_c('rect',{attrs:{"transform":"rotate(45 24,14.5)","height":"24","width":"24","y":"2.5","x":"12","fill":"#000000"}})]),_vm._v(" "),_c('g',{staticClass:"discord-eyes"})])]),_vm._v(" "),_c('mask',{attrs:{"id":"mask-outer-layer"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"#FFFFFF"}}),_vm._v(" "),_c('circle',{attrs:{"r":"42%","cx":"50%","cy":"50%","fill":"#000000"}})]),_vm._v(" "),_c('mask',{attrs:{"id":"mask-middle-layer"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"#000000"}}),_vm._v(" "),_c('circle',{attrs:{"r":"43%","cx":"50%","cy":"50%","fill":"#FFFFFF"}}),_vm._v(" "),_c('circle',{attrs:{"r":"32%","cx":"50%","cy":"50%","fill":"#000000"}})]),_vm._v(" "),_c('mask',{attrs:{"id":"mask-inner-layer"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"#000000"}}),_vm._v(" "),_c('circle',{attrs:{"r":"32%","cx":"50%","cy":"50%","fill":"#FFFFFF"}})])])]),_vm._v(" "),_c('g',{staticClass:"discord-logo"}),_vm._v(" "),(_vm.customLink)?_c('a',{attrs:{"href":_vm.customLink}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill-opacity":"0"}})]):_vm._e(),_vm._v(" "),(_vm.isRainbow)?_c('animate',{attrs:{"fill":"freeze","dur":"4000ms","begin":"0s","values":"#DA7272;#DABF72;#A6DA72;#72DA8C;#72DADA;#728CDA;#A672DA;#DA72C0;#DA7272","calMode":"linear","attributeName":"color","repeatCount":"indefinite"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DiscordLogo = (esExports);
// CONCATENATED MODULE: ./src/components/DiscordLogo.vue
function injectStyle (ssrContext) {
  __webpack_require__("xhcy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DiscordLogo,
  components_DiscordLogo,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DiscordLogo = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GithubCorner.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var GithubCorner = ({
  name: 'GithubCorner',
  props: {
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726b8157","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GithubCorner.vue
var GithubCorner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"github-corner"},[_c('svg',{attrs:{"width":"120","height":"120","viewBox":"0 0 250 250"}},[_c('a',{staticStyle:{"pointer-events":"auto"},attrs:{"fill":_vm.discordcolor,"href":"https://github.com/NNTin/discord-logo"}},[_c('path',{attrs:{"d":"M0,0 L250,250 L250,0 Z"}})]),_vm._v(" "),_c('g',{staticClass:"octocat"},[_c('path',{attrs:{"fill":_vm.discordfill,"d":"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"}}),_vm._v(" "),_c('path',{staticClass:"octo-arm",staticStyle:{"transform-origin":"130px 106px"},attrs:{"d":"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2","fill":_vm.discordcolor}}),_vm._v(" "),_c('path',{staticClass:"octo-body",attrs:{"d":"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z","fill":_vm.discordcolor}}),_vm._v(" "),_c('text',{staticClass:"octo-click-text",attrs:{"x":"240px","y":"-10px","stroke":_vm.discordcolor,"fill":_vm.discordcolor}},[_vm._v("CLICK")]),_vm._v(" "),_c('g',{staticClass:"octo-glasses",attrs:{"visibility":"hidden"}},[_c('svg',{attrs:{"fill":_vm.discordfill,"width":"640","height":"480"}},[_c('defs',[_c('symbol',{attrs:{"id":"glasses","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m465.4,247c-2.2,-22 -12.4,-43 -28.9,-58.4c-17.1,-15.9 -39.3,-24.7 -62.7,-24.7c-41.5,0 -77.3,27.4 -88.5,67c-7,-7 -18.5,-11.7 -29.3,-11.7c-10.8,0 -22.3,4.7 -29.3,11.7c-11.2,-39.6 -47,-67 -88.5,-67c-23.3,0 -45.6,8.7 -62.7,24.6c-16.5,15.5 -26.7,36.5 -28.9,58.5l-14.6,0l0,18l14.6,0c2.2,22 12.4,43 28.9,58.4c17.1,15.9 39.3,24.7 62.7,24.7c50.8,0 92.1,-41.2 92.1,-92c0,-0.1 0,-0.1 0,-0.1l0,0c0,-9.9 11.5,-21.6 25.7,-21.6s25.7,11.7 25.7,21.6l0,0c0,0 0,0 0,0.1c0,50.8 41.3,92 92.1,92c23.3,0 45.6,-8.7 62.7,-24.7c16.5,-15.4 26.7,-36.5 28.9,-58.5l14.6,0l0,-18l-14.6,0l0,0.1z"}})])]),_vm._v(" "),_c('g',[_c('use',{attrs:{"x":"530","y":"-70","xlink:href":"#glasses","transform":"rotate(45 100,75) matrix(0.185,0,0,0.185,0,0) "}})])])])])])])}
var GithubCorner_staticRenderFns = []
var GithubCorner_esExports = { render: GithubCorner_render, staticRenderFns: GithubCorner_staticRenderFns }
/* harmony default export */ var components_GithubCorner = (GithubCorner_esExports);
// CONCATENATED MODULE: ./src/components/GithubCorner.vue
function GithubCorner_injectStyle (ssrContext) {
  __webpack_require__("GlE0")
}
var GithubCorner_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GithubCorner___vue_template_functional__ = false
/* styles */
var GithubCorner___vue_styles__ = GithubCorner_injectStyle
/* scopeId */
var GithubCorner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GithubCorner___vue_module_identifier__ = null
var GithubCorner_Component = GithubCorner_normalizeComponent(
  GithubCorner,
  components_GithubCorner,
  GithubCorner___vue_template_functional__,
  GithubCorner___vue_styles__,
  GithubCorner___vue_scopeId__,
  GithubCorner___vue_module_identifier__
)

/* harmony default export */ var src_components_GithubCorner = (GithubCorner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DiscordCorner.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DiscordCorner = ({
  name: 'DiscordCorner',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    width: {
      type: Number,
      default: 120
    },
    height: {
      type: Number,
      default: 120
    },
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    },
    customLink: {
      type: String,
      default: ''
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714917e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiscordCorner.vue
var DiscordCorner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"color":_vm.discordcolor,"fill":_vm.discordfill,"width":_vm.width,"height":_vm.height,"viewBox":"0 0 250 250"}},[_c('g',[(this.customLink)?_c('a',{attrs:{"href":this.customLink}},[_c('path',{attrs:{"d":"M0,0 L0,250 L250,0 Z","fill":_vm.discordfill}})]):_c('path',{attrs:{"d":"M0,0 L0,250 L250,0 Z","fill":_vm.discordfill}})]),_vm._v(" "),_c('g',{staticClass:"discord-corner"},[_c('DiscordLogo',{attrs:{"discordEyes":_vm.discordEyes,"isRainbow":_vm.isRainbow,"animationStyle":_vm.animationStyle,"customLink":_vm.customLink,"color":_vm.discordcolor,"fill":_vm.discordfill,"width":120,"height":120}})],1)])}
var DiscordCorner_staticRenderFns = []
var DiscordCorner_esExports = { render: DiscordCorner_render, staticRenderFns: DiscordCorner_staticRenderFns }
/* harmony default export */ var components_DiscordCorner = (DiscordCorner_esExports);
// CONCATENATED MODULE: ./src/components/DiscordCorner.vue
function DiscordCorner_injectStyle (ssrContext) {
  __webpack_require__("QJtL")
}
var DiscordCorner_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DiscordCorner___vue_template_functional__ = false
/* styles */
var DiscordCorner___vue_styles__ = DiscordCorner_injectStyle
/* scopeId */
var DiscordCorner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DiscordCorner___vue_module_identifier__ = null
var DiscordCorner_Component = DiscordCorner_normalizeComponent(
  DiscordCorner,
  components_DiscordCorner,
  DiscordCorner___vue_template_functional__,
  DiscordCorner___vue_styles__,
  DiscordCorner___vue_scopeId__,
  DiscordCorner___vue_module_identifier__
)

/* harmony default export */ var src_components_DiscordCorner = (DiscordCorner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ColorSelector.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ColorSelector = ({
  name: 'ColorSelector',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    customLink: {
      type: String,
      default: ''
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    }
  },
  data: function data() {
    return {
      size: 48,
      colors: {
        discordcolor: '#FFFFFF',
        discordfill: '#7289DA'
      }
    };
  },

  computed: {},
  methods: {
    setColor: function setColor(backgroundColor, textColor) {
      this.colors.discordcolor = textColor, this.colors.discordfill = backgroundColor;
      this.$emit('colorChange', this.colors);
    },
    setRainbow: function setRainbow(value) {
      this.$emit('rainbowChange', value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffcfe97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorSelector.vue
var ColorSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},[_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#7289DA","discordcolor":"#FFFFFF"},nativeOn:{"click":function($event){_vm.setColor('#7289DA','#FFFFFF') + _vm.setRainbow(false)}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#7289DA","discordcolor":"#2C2F33"},nativeOn:{"click":function($event){_vm.setColor('#7289DA','#2C2F33') + _vm.setRainbow(false)}}}),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#FFFFFF","discordcolor":"#7289DA"},nativeOn:{"click":function($event){_vm.setColor('#FFFFFF','#7289DA') + _vm.setRainbow(false)}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#FFFFFF","discordcolor":"#2C2F33"},nativeOn:{"click":function($event){_vm.setColor('#FFFFFF','#2C2F33') + _vm.setRainbow(false)}}}),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#2C2F33","discordcolor":"#7289DA"},nativeOn:{"click":function($event){_vm.setColor('#2C2F33','#7289DA') + _vm.setRainbow(false)}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":"#2C2F33","discordcolor":"#FFFFFF"},nativeOn:{"click":function($event){_vm.setColor('#2C2F33','#FFFFFF') + _vm.setRainbow(false)}}})],1)}
var ColorSelector_staticRenderFns = []
var ColorSelector_esExports = { render: ColorSelector_render, staticRenderFns: ColorSelector_staticRenderFns }
/* harmony default export */ var components_ColorSelector = (ColorSelector_esExports);
// CONCATENATED MODULE: ./src/components/ColorSelector.vue
function ColorSelector_injectStyle (ssrContext) {
  __webpack_require__("2H6T")
}
var ColorSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ColorSelector___vue_template_functional__ = false
/* styles */
var ColorSelector___vue_styles__ = ColorSelector_injectStyle
/* scopeId */
var ColorSelector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ColorSelector___vue_module_identifier__ = null
var ColorSelector_Component = ColorSelector_normalizeComponent(
  ColorSelector,
  components_ColorSelector,
  ColorSelector___vue_template_functional__,
  ColorSelector___vue_styles__,
  ColorSelector___vue_scopeId__,
  ColorSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_ColorSelector = (ColorSelector_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StyleSelector.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var StyleSelector = ({
  name: 'StyleSelector',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    customLink: {
      type: String,
      default: ''
    },
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    }
  },
  data: function data() {
    return {
      size: 48
    };
  },

  computed: {
    rainbowActiveStyle: {
      get: function get() {
        if (this.isRainbow) {
          return { border: "solid 2px " + this.discordcolor };
        } else {
          return { border: "solid 2px transparent" };
        }
      }
    }
  },
  created: function created() {
    this.$nextTick(function () {
      setInterval(function () {
        var _this = this;

        this.addAnimatedClass();
        this.sleep(2500).then(function () {
          _this.removeAnimatedClass();
        });
      }.bind(this), 5000);
    });
  },
  methods: {
    setStyle: function setStyle(animationStyle) {
      this.$emit('styleChange', animationStyle);
    },
    sleep: function sleep(ms) {
      return new promise_default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    addAnimatedClass: function addAnimatedClass() {
      var rootElement = this.$refs.rootElement;
      var discordLogos = rootElement.getElementsByClassName("button");
      for (var i = 0; i < discordLogos.length; i++) {
        discordLogos[i].classList.add("animated");
      }
    },
    removeAnimatedClass: function removeAnimatedClass() {
      var rootElement = this.$refs.rootElement;
      var discordLogos = rootElement.getElementsByClassName("button");
      for (var i = 0; i < discordLogos.length; i++) {
        discordLogos[i].classList.remove("animated");
      }
    },
    isActive: function isActive(value) {
      if (this.animationStyle == value) {
        return { border: "solid 2px " + this.discordcolor };
      } else {
        return { border: "solid 2px transparent" };
      }
    },
    setRainbow: function setRainbow(value) {
      if (this.isRainbow ? !value : value) {
        this.$emit('rainbowChange', value);
      } else if (value && this.isRainbow) {
        this.$emit('rainbowChange', !this.isRainbow);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4a550c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StyleSelector.vue
var StyleSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rootElement",staticClass:"buttons"},[_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('swirl')),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"custom-link":_vm.customLink,"animation-style":"swirl","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor},nativeOn:{"click":function($event){_vm.setStyle('swirl')}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('rotateX')),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"custom-link":_vm.customLink,"animation-style":"rotateX","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor},nativeOn:{"click":function($event){_vm.setStyle('rotateX')}}}),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('rotateY')),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"custom-link":_vm.customLink,"animation-style":"rotateY","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor},nativeOn:{"click":function($event){_vm.setStyle('rotateY')}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('shake')),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"custom-link":_vm.customLink,"animation-style":"shake","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor},nativeOn:{"click":function($event){_vm.setStyle('shake')}}}),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('softshake')),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"custom-link":_vm.customLink,"animation-style":"softshake","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor},nativeOn:{"click":function($event){_vm.setStyle('softshake')}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.rainbowActiveStyle),attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":true,"custom-link":_vm.customLink,"animation-style":"none","width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill},nativeOn:{"click":function($event){_vm.setRainbow(true)}}})],1)}
var StyleSelector_staticRenderFns = []
var StyleSelector_esExports = { render: StyleSelector_render, staticRenderFns: StyleSelector_staticRenderFns }
/* harmony default export */ var components_StyleSelector = (StyleSelector_esExports);
// CONCATENATED MODULE: ./src/components/StyleSelector.vue
function StyleSelector_injectStyle (ssrContext) {
  __webpack_require__("sui6")
}
var StyleSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var StyleSelector___vue_template_functional__ = false
/* styles */
var StyleSelector___vue_styles__ = StyleSelector_injectStyle
/* scopeId */
var StyleSelector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StyleSelector___vue_module_identifier__ = null
var StyleSelector_Component = StyleSelector_normalizeComponent(
  StyleSelector,
  components_StyleSelector,
  StyleSelector___vue_template_functional__,
  StyleSelector___vue_styles__,
  StyleSelector___vue_scopeId__,
  StyleSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_StyleSelector = (StyleSelector_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/index.js
var dist = __webpack_require__("GDE4");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DiscordText.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DiscordText = ({
  name: 'DiscordText',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    height: {
      type: Number,
      default: 40
    },
    discordcolor: {
      type: String,
      default: '#FFFFFF'
    },
    discordfill: {
      type: String,
      default: '#7289DA'
    },
    customLink: {
      type: String,
      default: ''
    },
    standardText: {
      type: String,
      default: 'Join us on Discord!'
    },
    writeText: {
      type: Boolean,
      default: true
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    }
  },
  data: function data() {
    return {
      delay: 60,
      isTyping: false,
      bubbleText: '',
      width: 0,
      background: {
        type: String,
        default: 'none'
      }
    };
  },

  computed: {},
  watch: {
    standardText: function standardText() {
      var _this = this;

      if (!this.isTyping) {
        this.typeText(0, this.standardText);
      } else {
        this.delay = 0;
        this.sleep(500).then(function () {
          _this.delay = 60;
        });
      }
    }
  },
  created: function created() {
    this.$nextTick(function () {
      this.$refs.discordLogoFromText.update();
      this.typeText(0, this.standardText);
    });
  },
  methods: {
    typeText: function typeText(position, text) {
      var _this2 = this;

      if (this.writeText) {
        if (position == 0) {
          this.isTyping = true, this.bubbleText = '';
        }if (position < text.length) {
          this.bubbleText += text.charAt(position);
          this.sleep(this.delay).then(function () {
            _this2.typeText(position + 1, text);
          });
        } else {
          this.isTyping = false;
        }
      } else {
        this.bubbleText = text;
      }

      this.updateSVG();
    },
    sleep: function sleep(ms) {
      return new promise_default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    updateSVG: function updateSVG() {
      this.$nextTick(function () {
        var discordTextRootElement = this.$refs.discordTextRootElement;
        var speechbubble = discordTextRootElement.getElementsByClassName("speechbubble")[0];
        var textElement = discordTextRootElement.getElementsByClassName("textElement")[0];
        var newWidth = textElement.getComputedTextLength();
        var vb = [0, 0, newWidth + 190, 200];
        speechbubble.setAttribute("viewBox", vb.join(" "));

        var original_d = "M 154.5,0 L 20.5,0 C 9.2,0 0,9.2 0,20.6 L 0,155.8 C 0,167.2 9.2,177 20.5,176.4 L 133.9,176.4 L 128.6,157.9 L 141.4,169.8 L 153.5,181 L 175,200 L 175,20.6 C 175,9.2 165.8,0 154.5,0 Z";
        var d = original_d.split(" ");
        var new_d = [];
        for (var i = 0; i < d.length; i++) {
          switch (d[i]) {
            case 'M':
            case 'C':
            case 'L':
            case 'Z':
              new_d.push(d[i]);
              break;
            default:
              var coordinates = d[i].split(',');
              if (coordinates[0] < 50) {
                new_d.push(coordinates.join(","));
              } else {
                new_d.push([(parseFloat(coordinates[0]) + parseFloat(newWidth)).toString(), coordinates[1]].join(","));
              }
          }
        }
        var pathElement = discordTextRootElement.getElementsByClassName("pathElement")[0];
        pathElement.setAttribute("d", new_d.join(" "));
        var pathElementGroup = discordTextRootElement.getElementsByClassName("pathElementGroup")[0];
        pathElementGroup.setAttribute("transform", 'translate(' + parseFloat(newWidth + 190).toString() + ', 0)');
      });
      this.$emit('htmlModified');
    },
    updateSVGContainer: function updateSVGContainer() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa339cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiscordText.vue
var DiscordText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"discordTextRootElement"},[_c('div',{staticClass:"discordtext"},[_c('DiscordLogo',{ref:"discordLogoFromText",attrs:{"background":_vm.background,"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"height":_vm.height *2,"width":_vm.height *2,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor}}),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.standardText),expression:"standardText"}],staticClass:"speechbubble",attrs:{"height":_vm.height,"preserveAspectRatio":"xMinYMin"}},[_c('g',{staticClass:"pathElementGroup"},[_c('path',{staticClass:"pathElement",attrs:{"transform":"scale(-1,1)","fill":_vm.discordcolor,"d":"M 154.5,0 L 20.5,0 C 9.2,0 0,9.2 0,20.6 L 0,155.8 C 0,167.2 9.2,177 20.5,176.4 L 133.9,176.4 L 128.6,157.9 L 141.4,169.8 L 153.5,181 L 175,200 L 175,20.6 C 175,9.2 165.8,0 154.5,0 Z"}})]),_vm._v(" "),_c('text',{staticClass:"textElement",attrs:{"fill":_vm.discordfill,"font-size":"90","x":"95","y":"57%"}},[_vm._v(_vm._s(_vm.bubbleText))]),_vm._v(" "),(_vm.customLink)?_c('a',{attrs:{"href":_vm.customLink}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill-opacity":"0"}})]):_vm._e()])],1)])}
var DiscordText_staticRenderFns = []
var DiscordText_esExports = { render: DiscordText_render, staticRenderFns: DiscordText_staticRenderFns }
/* harmony default export */ var components_DiscordText = (DiscordText_esExports);
// CONCATENATED MODULE: ./src/components/DiscordText.vue
function DiscordText_injectStyle (ssrContext) {
  __webpack_require__("moOw")
}
var DiscordText_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DiscordText___vue_template_functional__ = false
/* styles */
var DiscordText___vue_styles__ = DiscordText_injectStyle
/* scopeId */
var DiscordText___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DiscordText___vue_module_identifier__ = null
var DiscordText_Component = DiscordText_normalizeComponent(
  DiscordText,
  components_DiscordText,
  DiscordText___vue_template_functional__,
  DiscordText___vue_styles__,
  DiscordText___vue_scopeId__,
  DiscordText___vue_module_identifier__
)

/* harmony default export */ var src_components_DiscordText = (DiscordText_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-color/dist/vue-color.min.js
var vue_color_min = __webpack_require__("Zzkc");
var vue_color_min_default = /*#__PURE__*/__webpack_require__.n(vue_color_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MainBody.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var MainBody = ({
  name: 'MainBody',
  components: {
    DiscordText: src_components_DiscordText,
    DiscordLogo: src_components_DiscordLogo,
    DiscordCorner: src_components_DiscordCorner,
    vueSlider: dist_default.a,
    'chrome-picker': vue_color_min["Chrome"]
  },
  props: {
    previewDiscordType: {
      type: String,
      default: "corner"
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    },
    background: {
      type: String,
      default: 'none'
    }
  },
  data: function data() {
    return {
      bubbleText: 'Join us on Discord!',
      previewCode: "",
      size: 100,
      isLeft: true,
      isTop: true,
      rotation: "",

      colors: {
        discordcolor: {
          hex: '#FFFFFF',
          hsl: {
            h: 144,
            s: 0,
            l: 1,
            a: 1
          },
          hsv: {
            h: 90,
            s: 0,
            v: 0,
            a: 1
          },
          rgba: {
            r: 255,
            g: 255,
            b: 255,
            a: 1
          },
          a: 1
        },
        discordfill: {
          hex: '#7289DA',
          hsl: {
            h: 227,
            s: 0.58,
            l: 0.65,
            a: 1
          },
          hsv: {
            h: 0,
            s: 0,
            v: 0,
            a: 1
          },
          rgba: {
            r: 114,
            g: 137,
            b: 218,
            a: 1
          },
          a: 1
        }
      },
      customLink: ""
    };
  },

  computed: {
    getDTextStyle: {
      get: function get() {
        return { backgroundColor: this.colors.discordfill.hex };
      }
    },
    getDCornerStyle: {
      get: function get() {
        var returnThis = { transform: "rotate(0deg)", backgroundColor: "#FFFFFF" };
        if (this.colors.discordfill.hex == "#FFFFFF") {
          returnThis.backgroundColor = this.colors.discordcolor.hex;
        } else {
          returnThis.backgroundColor = '#FFFFFF';
        }
        if (!this.isLeft && this.isTop) {
          this.rotation = 'transform: rotateY(180deg);';
          returnThis.transform = "rotateY(180deg)";
          return returnThis;
        } else if (!this.isLeft && !this.isTop) {
          this.rotation = 'transform: rotateY(180deg) rotateX(180deg);';
          returnThis.transform = "rotateY(180deg) rotateX(180deg)";
          return returnThis;
        } else if (this.isLeft && !this.isTop) {
          this.rotation = 'transform: rotateX(180deg);';
          returnThis.transform = "rotateX(180deg)";
          return returnThis;
        } else {
          return returnThis;
        }
      }
    },
    isClickable: {
      get: function get() {
        return this.customLink == "" ? false : true;
      }
    }
  },
  watch: {
    previewDiscordType: function previewDiscordType() {
      this.updatePreviewCode();
    },
    isRainbow: function isRainbow() {
      this.updatePreviewCode();
    },
    size: function size() {
      this.updatePreviewCode();
    },
    isLeft: function isLeft() {
      this.updatePreviewCode();
    },
    isTop: function isTop() {
      this.updatePreviewCode();
    },
    colors: {
      handler: function handler() {
        this.updatePreviewCode();
      },
      deep: true
    },
    customLink: function customLink() {
      this.updatePreviewCode();
    }
  },
  created: function created() {
    this.$nextTick(function () {
      this.updatePreviewCode();
    });
  },
  methods: {
    refreshSlider: function refreshSlider() {
      this.$nextTick(function () {
        this.$refs.vueSlider.refresh();
      });
    },
    onHtmlModified: function onHtmlModified() {
      this.updatePreviewCode();
    },
    changeColor: function changeColor(discordcolor, discordfill) {
      this.colors.discordcolor = { hex: discordcolor, a: 1 };
      this.colors.discordfill = { hex: discordfill, a: 1 };
    },
    //changeBackground: function (background) {
    //  this.background = background
    //},
    updatePreviewCode: function updatePreviewCode() {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
        if (this.$refs.preview == null) {
          this.previewCode = "";
        } else {
          this.previewCode = this.$refs.preview.innerHTML;
          var styleCode = "* { font-family: 'Avenir', Helvetica, Arial, sans-serif; } .discord-logo { transform: scale(0.7); transform-origin: 24px 24px; } ";
          // this.previewDiscordType     //corner standard speechbubble
          // this.animationStyle         //shake swirl rotateX rotateY
          if (this.previewDiscordType == "corner") {
            styleCode += ".discord-corner { transform: rotate(-45deg); transform-origin: 60px 60px; }";
          } else if (this.previewDiscordType == "speechbubble") {
            styleCode += ".speechbubble { position: relative; transform: translateY(-50%); } .discordtext { opacity: 0.75; } .discordtext:hover { opacity: 1; } .discordtext a { text-decoration: none; }";
          }
          if (this.animationStyle == "rotateX") {
            styleCode += ".discord-logo.rotateX-animation .discord-original { transition: transform 300ms linear; transform-origin: 50% 50%; } .discord-logo-container:hover .rotateX-animation .discord-original, .animated .rotateX-animation .discord-original { transform: rotateX(360deg); }";
          } else if (this.animationStyle == "rotateY") {
            styleCode += ".discord-logo.rotateY-animation .discord-original { transition: transform 300ms linear; transform-origin: 50% 50%; } .discord-logo-container:hover .rotateY-animation .discord-original, .animated .rotateY-animation .discord-original { transform: rotateY(180deg); }";
          } else if (this.animationStyle == "swirl") {
            styleCode += ".discord-logo.swirl-animation .discord-outer-layer { transition: transform 800ms cubic-bezier(0.7, 1, 0.7, 1); transform-origin: 50% 50%; } .discord-logo-container:hover .swirl-animation .discord-outer-layer, .animated .swirl-animation .discord-outer-layer { transform: scale(1.5) rotate(360deg); } .discord-logo.swirl-animation .discord-middle-layer { transition: transform 800ms cubic-bezier(0.5, 1, 0.5, 1); transform-origin: 50% 50%; } .discord-logo-container:hover .swirl-animation .discord-middle-layer, .animated .swirl-animation .discord-middle-layer { transform: scale(1.4) rotate(360deg); } .discord-logo.swirl-animation .discord-inner-layer { transition: transform 800ms cubic-bezier(0.3, 1, 0.3, 1); transform-origin: 50% 50%; } .discord-logo-container:hover .swirl-animation .discord-inner-layer, .animated .swirl-animation .discord-inner-layer { transform: scale(1.3) rotate(360deg); } .discord-logo.swirl-animation .discord-original { transition: visibility 0ms; transition-delay: 800ms; } .discord-logo-container:hover .swirl-animation .discord-original, .animated .swirl-animation .discord-original { visibility: hidden; transition-delay: 0ms; }";
          } else if (this.animationStyle == "shake") {
            styleCode += ".discord-logo.shake-animation .discord-original { } .discord-logo-container:hover .shake-animation .discord-original, .animated .shake-animation .discord-original { animation-name:shake; animation-duration:100ms; animation-timing-function:ease-in-out; animation-iteration-count:infinite } @keyframes shake { 2% {transform:translate(.5px, 1.5px) rotate(1.5deg)} 4% {transform:translate(.5px, 1.5px) rotate(1.5deg)} 6% {transform:translate(-1.5px, -1.5px) rotate(-.5deg)} 8% {transform:translate(.5px, -.5px) rotate(.5deg)} 10% {transform:translate(.5px, 2.5px) rotate(.5deg)} 12% {transform:translate(2.5px, 1.5px) rotate(-.5deg)} 14% {transform:translate(-1.5px, 2.5px) rotate(-.5deg)} 16% {transform:translate(-.5px, .5px) rotate(.5deg)} 18% {transform:translate(.5px, 2.5px) rotate(1.5deg)} 20% {transform:translate(-.5px, -.5px) rotate(.5deg)} 22% {transform:translate(2.5px, .5px) rotate(-.5deg)} 24% {transform:translate(-1.5px, -1.5px) rotate(.5deg)} 26% {transform:translate(2.5px, -.5px) rotate(-.5deg)} 28% {transform:translate(1.5px, -.5px) rotate(.5deg)} 30% {transform:translate(.5px, .5px) rotate(-.5deg)} 32% {transform:translate(-1.5px, .5px) rotate(-.5deg)} 34% {transform:translate(.5px, 2.5px) rotate(-.5deg)} 36% {transform:translate(-.5px, -.5px) rotate(1.5deg)} 38% {transform:translate(-1.5px, -1.5px) rotate(.5deg)} 40% {transform:translate(-1.5px, 1.5px) rotate(1.5deg)} 42% {transform:translate(.5px, -1.5px) rotate(1.5deg)} 44% {transform:translate(.5px, .5px) rotate(.5deg)} 46% {transform:translate(-1.5px, -1.5px) rotate(1.5deg)} 48% {transform:translate(.5px, -1.5px) rotate(.5deg)} 50% {transform:translate(2.5px, .5px) rotate(-.5deg)} 52% {transform:translate(-.5px, 2.5px) rotate(-.5deg)} 54% {transform:translate(.5px, .5px) rotate(.5deg)} 56% {transform:translate(-1.5px, 2.5px) rotate(.5deg)} 58% {transform:translate(2.5px, .5px) rotate(.5deg)} 60% {transform:translate(-1.5px, 2.5px) rotate(.5deg)} 62% {transform:translate(1.5px, -.5px) rotate(-.5deg)} 64% {transform:translate(1.5px, -1.5px) rotate(1.5deg)} 66% {transform:translate(1.5px, -1.5px) rotate(-.5deg)} 68% {transform:translate(.5px, 2.5px) rotate(-.5deg)} 70% {transform:translate(1.5px, -1.5px) rotate(1.5deg)} 72% {transform:translate(1.5px, 1.5px) rotate(-.5deg)} 74% {transform:translate(-.5px, 1.5px) rotate(1.5deg)} 76% {transform:translate(1.5px, 2.5px) rotate(.5deg)} 78% {transform:translate(-.5px, .5px) rotate(.5deg)} 80% {transform:translate(-1.5px, 2.5px) rotate(.5deg)} 82% {transform:translate(.5px, 2.5px) rotate(-.5deg)} 84% {transform:translate(2.5px, -.5px) rotate(.5deg)} 86% {transform:translate(1.5px, .5px) rotate(.5deg)} 88% {transform:translate(-.5px, -1.5px) rotate(-.5deg)} 90% {transform:translate(1.5px, -.5px) rotate(1.5deg)} 92% {transform:translate(.5px, 2.5px) rotate(.5deg)} 94% {transform:translate(2.5px, .5px) rotate(-.5deg)} 96% {transform:translate(.5px, 2.5px) rotate(.5deg)} 98% {transform:translate(2.5px, -1.5px) rotate(1.5deg)} 0%,100% {transform:translate(0, 0) rotate(0)} }";
          } else if (this.animationStyle == "softshake") {
            styleCode += ".discord-logo.softshake-animation .discord-original { transform-origin: 24px 24px; } .discord-logo-container:hover .softshake-animation .discord-original, .animated .softshake-animation .discord-original { animation: softshake 2000ms linear forwards; } @keyframes softshake { 0%,66%,100% {transform:rotate( 0deg)} 3% {transform:rotate(-18.0deg)} 6% {transform:rotate( 14.4deg)} 9% {transform:rotate(-11.5deg)} 12% {transform:rotate( 9.21deg)} 15% {transform:rotate(-7.37deg)} 18% {transform:rotate( 5.89deg)} 21% {transform:rotate(-4.71deg)} 24% {transform:rotate( 3.77deg)} 27% {transform:rotate(-3.02deg)} 30% {transform:rotate( 2.41deg)} 33% {transform:rotate(-1.93deg)} 36% {transform:rotate( 1.54deg)} 39% {transform:rotate(-1.23deg)} 42% {transform:rotate( 0.99deg)} 45% {transform:rotate(-0.79deg)} 48% {transform:rotate( 0.63deg)} 51% {transform:rotate(-0.50deg)} 54% {transform:rotate( 0.40deg)} 57% {transform:rotate(-0.32deg)} 60% {transform:rotate( 0.25deg)} 63% {transform:rotate(-0.20deg)} }";
          }
          this.previewCode += "\n\n<style type='text/css'>" + styleCode + "</style>";
          switch (this.background) {
            case 'starfield':
              this.previewCode += '\n\n<script>var discordCanvas = document.getElementById("discordCanvas");var discordCtx = discordCanvas.getContext("2d");var discordFrames = 0;(function drawDiscordAnimation () {discordCanvas.style.width = "50px";discordCanvas.style.height = "50px";discordCanvas.width = 250;discordCanvas.height = 250;discordCtx.fillStyle="#fff8";for(let j=250, w=100, p=0; j--;){let Z=1-(j*j/w+discordFrames/100)%1;let s=1+Math.pow(5*(1-Z),2)/2;discordCtx.beginPath();discordCtx.arc(w+(99-j%199)/Z,100+(99-j*j*7%198)/Z,s,0,7);discordCtx.fill()};discordFrames++;requestAnimationFrame(drawDiscordAnimation)}());<' + '/script>';
              break;
            case 'grid':
              this.previewCode += '\n\n<script>var discordCanvas = document.getElementById("discordCanvas");var discordCtx = discordCanvas.getContext("2d");var discordFrames = 0;(function drawDiscordAnimation () {discordCanvas.style.width = "50px";discordCanvas.style.height = "50px";discordCanvas.width = 250;discordCanvas.height = 250;discordCtx.strokeStyle="#fff4";var w=120,i=200,t=discordFrames/70,X=0,Z=0;var r=q=>discordCtx[q?"lineTo":"moveTo"](w+(X-7)/Z*w*2,2/Z*w);for(;i--;discordCtx.lineWidth=0.5+8/(1+Z),r(Z++),r(X--),discordCtx.stroke())discordCtx.beginPath(),X=(i+Math.sin(t)*4)%14,Z=1+(i/14|0)-t*5%1,r();discordFrames++;requestAnimationFrame(drawDiscordAnimation)}());<' + '/script>';
              break;
            case 'rush':
              this.previewCode += '\n\n<script>var discordCanvas = document.getElementById("discordCanvas");var discordCtx = discordCanvas.getContext("2d");var discordFrames = 0;(function drawDiscordAnimation () {discordCanvas.style.width = "50px";discordCanvas.style.height = "50px";discordCanvas.width = 250;discordCanvas.height = 250;discordCtx.fillStyle="#fff3";var W=120,j=10,i=0,p=0,V=0,Z=0,s=0,t=discordFrames/200; for(;--j;)for(i=16;i--;discordCtx.fillRect(W+Math.sin(p=.39*i+j/8-6.03*V-Math.sin(t*2)*3)/Z*W-s/2,120+Math.cos(p)/Z*W-s/2,s,s))Z=.5+j/2-t*6+(V=(t*6)|0),s=200/(1+Z)/(1+Z)/(1+Z);discordFrames++;requestAnimationFrame(drawDiscordAnimation)}());<' + '/script>';
              break;
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714d7603","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainBody.vue
var MainBody_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('portal-target',{attrs:{"name":"destination"}}),_vm._v(" "),_c('section',[_c('div',{staticClass:"left"},[_c('vueSlider',{ref:"vueSlider",attrs:{"reverse":true,"direction":"vertical","width":4,"height":482,"min":18,"max":250},model:{value:(_vm.size),callback:function ($$v) {_vm.size=$$v},expression:"size"}}),_vm._v(" "),_c('div',{staticClass:"stack"},[_c('div',{staticClass:"input"},[_c('toggle-button',{staticClass:"button",attrs:{"color":{checked: '#76DA72', unchecked: '#DA7272'},"disabled":_vm.previewDiscordType != 'corner',"labels":{checked: 'left', unchecked: 'right'},"width":100},model:{value:(_vm.isLeft),callback:function ($$v) {_vm.isLeft=$$v},expression:"isLeft"}}),_vm._v(" "),_c('toggle-button',{staticClass:"button",attrs:{"color":{checked: '#7289DA', unchecked: '#D4DA72'},"disabled":_vm.previewDiscordType != 'corner',"labels":{checked: 'top', unchecked: 'bottom'},"width":100},model:{value:(_vm.isTop),callback:function ($$v) {_vm.isTop=$$v},expression:"isTop"}}),_vm._v(" "),_c('toggle-button',{staticClass:"button",attrs:{"color":{checked: '#2BA027', unchecked: '#B9B6B6'},"sync":true,"disabled":true,"labels":{checked: 'clickable link', unchecked: 'no link'},"width":100},model:{value:(_vm.isClickable),callback:function ($$v) {_vm.isClickable=$$v},expression:"isClickable"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customLink),expression:"customLink"}],staticClass:"text",attrs:{"size":30,"placeholder":"insert link (e.g. discord invite link)"},domProps:{"value":(_vm.customLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.customLink=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bubbleText),expression:"bubbleText"}],staticClass:"text",attrs:{"size":30,"placeholder":"insert text"},domProps:{"value":(_vm.bubbleText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bubbleText=$event.target.value}}})],1),_vm._v(" "),_c('portal',{attrs:{"to":"destination","disabled":_vm.previewDiscordType != 'speechbubble'}},[_c('div',{ref:"preview",attrs:{"id":"preview"}},[(_vm.previewDiscordType == 'standard')?_c('DiscordLogo',{staticClass:"previewbox",attrs:{"discord-eyes":_vm.discordEyes,"background":_vm.background,"is-rainbow":_vm.isRainbow,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.colors.discordfill.hex,"discordcolor":_vm.colors.discordcolor.hex}}):(_vm.previewDiscordType == 'speechbubble')?_c('DiscordText',{ref:"discordtext",staticClass:"previewbox previewDiscordText",style:(_vm.getDTextStyle),attrs:{"discord-eyes":_vm.discordEyes,"background":_vm.background,"is-rainbow":_vm.isRainbow,"animation-style":_vm.animationStyle,"custom-link":_vm.customLink,"height":_vm.size/4,"standard-text":_vm.bubbleText,"discordfill":_vm.colors.discordfill.hex,"discordcolor":_vm.colors.discordcolor.hex,"write-text":false},on:{"htmlModified":_vm.onHtmlModified}}):_c('DiscordCorner',{staticClass:"previewbox",style:(_vm.getDCornerStyle),attrs:{"discord-eyes":_vm.discordEyes,"custom-link":_vm.customLink,"is-rainbow":_vm.isRainbow,"animation-style":_vm.animationStyle,"width":_vm.size,"height":_vm.size,"discordfill":_vm.colors.discordfill.hex,"discordcolor":_vm.colors.discordcolor.hex}})],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"color-picker"},[_c('chrome-picker',{model:{value:(_vm.colors.discordcolor),callback:function ($$v) {_vm.$set(_vm.colors, "discordcolor", $$v)},expression:"colors.discordcolor"}}),_vm._v(" "),_c('chrome-picker',{model:{value:(_vm.colors.discordfill),callback:function ($$v) {_vm.$set(_vm.colors, "discordfill", $$v)},expression:"colors.discordfill"}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.previewCode),expression:"previewCode"}],domProps:{"value":(_vm.previewCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.previewCode=$event.target.value}}})]),_vm._v(" "),_vm._m(1,false,false)],1)}
var MainBody_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_vm._v("Animated Discord Logo")]),_vm._v(" "),_c('p',[_vm._v("This project was inspired by "),_c('a',{attrs:{"href":"https://canary.discordapp.com/assets/0bdc0497eb3a19e66f2b1e3d5741634c.webm"}},[_vm._v("Discord's loading logo.")])]),_vm._v(" "),_c('p',[_vm._v("Since the loading logo is a video you have less control over its behavior. This project recreates the animated logo in "),_c('b',[_vm._v("S")]),_vm._v("caleable "),_c('b',[_vm._v("V")]),_vm._v("ector "),_c('b',[_vm._v("G")]),_vm._v("raphics. By using "),_c('b',[_vm._v("SVG")]),_vm._v(", all edges are clean and sharp. You can have any size and color. It consumes less resources compared to a video. Original SVG and color palette were retrieved from "),_c('a',{attrs:{"href":"https://discordapp.com/branding"}},[_vm._v("Discord")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("If you need help, feel free joining "),_c('a',{attrs:{"href":"https://discord.gg/gDHs8AV"}},[_vm._v("my server")]),_vm._v(". Below is a code generator:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("This project is neither built nor endorsed by Discord.")])])}]
var MainBody_esExports = { render: MainBody_render, staticRenderFns: MainBody_staticRenderFns }
/* harmony default export */ var components_MainBody = (MainBody_esExports);
// CONCATENATED MODULE: ./src/components/MainBody.vue
function MainBody_injectStyle (ssrContext) {
  __webpack_require__("/xwR")
}
var MainBody_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MainBody___vue_template_functional__ = false
/* styles */
var MainBody___vue_styles__ = MainBody_injectStyle
/* scopeId */
var MainBody___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainBody___vue_module_identifier__ = null
var MainBody_Component = MainBody_normalizeComponent(
  MainBody,
  components_MainBody,
  MainBody___vue_template_functional__,
  MainBody___vue_styles__,
  MainBody___vue_scopeId__,
  MainBody___vue_module_identifier__
)

/* harmony default export */ var src_components_MainBody = (MainBody_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EyeSelector.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EyeSelector = ({
  name: 'EyeSelector',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    customLink: {
      type: String,
      default: ''
    },
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    }
  },
  data: function data() {
    return {
      size: 100
    };
  },

  computed: {},
  created: function created() {},
  methods: {
    setEye: function setEye(eyeStyle) {
      this.$emit('activeEyeChange', eyeStyle);
    },
    sleep: function sleep(ms) {
      return new promise_default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    isActive: function isActive(value) {
      if (this.discordEyes == value) {
        return { border: "solid 2px " + this.discordcolor };
      } else {
        return { border: "solid 2px transparent" };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81889244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EyeSelector.vue
var EyeSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eyeSelector"},[_c('DiscordLogo',{style:(_vm.isActive('wink')),attrs:{"discord-eyes":"wink","custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setEye('wink')}}}),_vm._v(" "),_c('DiscordLogo',{style:(_vm.isActive('none')),attrs:{"discord-eyes":"none","custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setEye('none')}}}),_vm._v(" "),_c('DiscordLogo',{style:(_vm.isActive('angry')),attrs:{"discord-eyes":"angry","custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setEye('angry')}}}),_vm._v(" "),_c('DiscordLogo',{style:(_vm.isActive('noeyes')),attrs:{"discord-eyes":"noeyes","custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setEye('noeyes')}}})],1)}
var EyeSelector_staticRenderFns = []
var EyeSelector_esExports = { render: EyeSelector_render, staticRenderFns: EyeSelector_staticRenderFns }
/* harmony default export */ var components_EyeSelector = (EyeSelector_esExports);
// CONCATENATED MODULE: ./src/components/EyeSelector.vue
function EyeSelector_injectStyle (ssrContext) {
  __webpack_require__("iVUo")
}
var EyeSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EyeSelector___vue_template_functional__ = false
/* styles */
var EyeSelector___vue_styles__ = EyeSelector_injectStyle
/* scopeId */
var EyeSelector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EyeSelector___vue_module_identifier__ = null
var EyeSelector_Component = EyeSelector_normalizeComponent(
  EyeSelector,
  components_EyeSelector,
  EyeSelector___vue_template_functional__,
  EyeSelector___vue_styles__,
  EyeSelector___vue_scopeId__,
  EyeSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_EyeSelector = (EyeSelector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BackgroundSelector.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var BackgroundSelector = ({
  name: 'BackgroundSelector',
  components: {
    DiscordLogo: src_components_DiscordLogo
  },
  props: {
    customLink: {
      type: String,
      default: ''
    },
    discordcolor: {
      type: String,
      default: '#7289DA'
    },
    discordfill: {
      type: String,
      default: '#23272A'
    },
    isRainbow: {
      type: Boolean,
      default: false
    },
    discordEyes: {
      type: String,
      default: 'none' //none wink angry noeyes
    },
    animationStyle: {
      type: String,
      default: 'swirl'
    },
    background: {
      type: String,
      default: 'none'
    }
  },
  data: function data() {
    return {
      size: 48
    };
  },

  created: function created() {
    this.$nextTick(function () {
      setInterval(function () {
        var _this = this;

        this.addAnimatedClass();
        this.sleep(2500).then(function () {
          _this.removeAnimatedClass();
        });
      }.bind(this), 5000);
    });
  },
  methods: {
    setBackground: function setBackground(background) {
      this.$emit('backgroundChange', background);
    },
    sleep: function sleep(ms) {
      return new promise_default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    addAnimatedClass: function addAnimatedClass() {
      var rootElement = this.$refs.rootElement;
      var discordLogos = rootElement.getElementsByClassName("button");
      for (var i = 0; i < discordLogos.length; i++) {
        discordLogos[i].classList.add("animated");
      }
    },
    removeAnimatedClass: function removeAnimatedClass() {
      var rootElement = this.$refs.rootElement;
      var discordLogos = rootElement.getElementsByClassName("button");
      for (var i = 0; i < discordLogos.length; i++) {
        discordLogos[i].classList.remove("animated");
      }
    },
    isActive: function isActive(value) {
      if (this.background == value) {
        return { border: "solid 2px " + this.discordcolor };
      } else {
        return { border: "solid 2px transparent" };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f0856e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackgroundSelector.vue
var BackgroundSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rootElement",staticClass:"buttons"},[_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('none')),attrs:{"background":"none","animation-style":_vm.animationStyle,"discord-eyes":_vm.discordEyes,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setBackground('none')}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('starfield')),attrs:{"background":"starfield","animation-style":_vm.animationStyle,"discord-eyes":_vm.discordEyes,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setBackground('starfield')}}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('grid')),attrs:{"background":"grid","animation-style":_vm.animationStyle,"discord-eyes":_vm.discordEyes,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setBackground('grid')}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('DiscordLogo',{staticClass:"button",style:(_vm.isActive('rush')),attrs:{"background":"rush","animation-style":_vm.animationStyle,"discord-eyes":_vm.discordEyes,"custom-link":_vm.customLink,"width":_vm.size,"height":_vm.size,"discordfill":_vm.discordfill,"discordcolor":_vm.discordcolor,"is-rainbow":_vm.isRainbow},nativeOn:{"click":function($event){_vm.setBackground('rush')}}}),_vm._v(" "),_c('br')],1)}
var BackgroundSelector_staticRenderFns = []
var BackgroundSelector_esExports = { render: BackgroundSelector_render, staticRenderFns: BackgroundSelector_staticRenderFns }
/* harmony default export */ var components_BackgroundSelector = (BackgroundSelector_esExports);
// CONCATENATED MODULE: ./src/components/BackgroundSelector.vue
function BackgroundSelector_injectStyle (ssrContext) {
  __webpack_require__("FaNk")
}
var BackgroundSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var BackgroundSelector___vue_template_functional__ = false
/* styles */
var BackgroundSelector___vue_styles__ = BackgroundSelector_injectStyle
/* scopeId */
var BackgroundSelector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BackgroundSelector___vue_module_identifier__ = null
var BackgroundSelector_Component = BackgroundSelector_normalizeComponent(
  BackgroundSelector,
  components_BackgroundSelector,
  BackgroundSelector___vue_template_functional__,
  BackgroundSelector___vue_styles__,
  BackgroundSelector___vue_scopeId__,
  BackgroundSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_BackgroundSelector = (BackgroundSelector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var App = ({
  name: 'App',
  components: {
    DiscordLogo: src_components_DiscordLogo, GithubCorner: src_components_GithubCorner, DiscordCorner: src_components_DiscordCorner, ColorSelector: src_components_ColorSelector,
    StyleSelector: src_components_StyleSelector, MainBody: src_components_MainBody, DiscordText: src_components_DiscordText, EyeSelector: src_components_EyeSelector, BackgroundSelector: src_components_BackgroundSelector
  },
  data: function data() {
    return {
      background: new URL(document.URL).searchParams.get("background") ? new URL(document.URL).searchParams.get("background") : 'none', //none starfield grid rush
      discordEyes: new URL(document.URL).searchParams.get("eyes") ? new URL(document.URL).searchParams.get("eyes") : 'none', //none wink angry noeyes
      isRainbow: new URL(document.URL).searchParams.get("rainbow") ? true : false,
      animationStyle: new URL(document.URL).searchParams.get("animation") ? new URL(document.URL).searchParams.get("animation") : 'swirl', //swirl rotateX rotateY shake softshake
      standardText: 'Join us on Discord',
      previewDiscordType: new URL(document.URL).searchParams.get("preview") ? new URL(document.URL).searchParams.get("preview") : 'standard', //corner standard speechbubble
      colors: {
        discordcolor: '#FFFFFF',
        discordfill: '#7289DA'
      }
    };
  },

  computed: {
    getBackgroundColor: {
      get: function get() {
        return {
          backgroundColor: this.colors.discordfill
        };
      }
    }
  },
  created: function created() {
    this.updateSpeechBubble();
  },
  methods: {
    updateSpeechBubble: function updateSpeechBubble() {
      var myArray = ['Click me to get the speech bubble code generator!', 'Click top right GitHub corner to fork!', 'Animation or style ideas? Raise an issue on GitHub!', 'Created with ♥ by NNTin using Vue.js', 'Click on the Discord corner to get the code.', 'All discord logos are clickable and will not redirect you!'];
      var rand = myArray[Math.floor(Math.random() * myArray.length)];
      this.standardText = rand;
    },
    onActiveEyeChange: function onActiveEyeChange(value) {
      this.discordEyes = value;
      this.$nextTick(function () {
        this.$refs.mainbody.updatePreviewCode();
      });
    },
    onColorChange: function onColorChange(value) {
      this.colors = value;
      this.$refs.mainbody.changeColor(this.colors.discordcolor, this.colors.discordfill);
    },
    onRainbowChange: function onRainbowChange(value) {
      this.isRainbow = value;
      this.$nextTick(function () {
        this.$refs.styleselector.isRainbowSelected = value;
        this.$refs.mainbody.updatePreviewCode();
      });
    },
    onStyleChange: function onStyleChange(value) {
      this.animationStyle = value;
      this.$nextTick(function () {
        this.$refs.mainbody.updatePreviewCode();
      });
    },
    setPreviewType: function setPreviewType(value) {
      this.previewDiscordType = value;
      this.$nextTick(function () {
        this.$refs.mainbody.refreshSlider();
        this.$refs.mainbody.updatePreviewCode();
      });
    },
    onBackgroundChange: function onBackgroundChange(value) {
      this.background = value;
      this.$nextTick(function () {
        this.$refs.mainbody.updatePreviewCode();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45971786","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:(_vm.getBackgroundColor),attrs:{"id":"top"}},[_c('GithubCorner',{attrs:{"discordcolor":_vm.colors.discordfill,"discordfill":_vm.colors.discordcolor}}),_vm._v(" "),_c('DiscordCorner',{attrs:{"id":"discordcorner","background":_vm.background,"discord-eyes":_vm.discordEyes,"custom-link":"#","is-rainbow":_vm.isRainbow,"animation-style":_vm.animationStyle,"discordcolor":_vm.colors.discordfill,"discordfill":_vm.colors.discordcolor},nativeOn:{"click":function($event){_vm.setPreviewType('corner')}}}),_vm._v(" "),_c('div',{attrs:{"id":"container"}},[_c('ColorSelector',{staticClass:"box",attrs:{"discord-eyes":_vm.discordEyes,"background":_vm.background,"custom-link":"#","animation-style":_vm.animationStyle},on:{"colorChange":_vm.onColorChange,"rainbowChange":_vm.onRainbowChange}}),_vm._v(" "),_c('BackgroundSelector',{staticClass:"box",attrs:{"background":_vm.background,"discord-eyes":_vm.discordEyes,"custom-link":"#","animation-style":_vm.animationStyle,"discordfill":_vm.colors.discordfill,"discordcolor":_vm.colors.discordcolor,"is-rainbow":_vm.isRainbow},on:{"backgroundChange":_vm.onBackgroundChange,"rainbowChange":_vm.onRainbowChange}}),_vm._v(" "),_c('StyleSelector',{ref:"styleselector",staticClass:"box",attrs:{"background":_vm.background,"animation-style":_vm.animationStyle,"discord-eyes":_vm.discordEyes,"custom-link":"#","is-rainbow":_vm.isRainbow,"discordfill":_vm.colors.discordfill,"discordcolor":_vm.colors.discordcolor},on:{"rainbowChange":_vm.onRainbowChange,"styleChange":_vm.onStyleChange}}),_vm._v(" "),_c('DiscordLogo',{staticClass:"box",attrs:{"discord-eyes":_vm.discordEyes,"background":_vm.background,"custom-link":"#","animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow,"discordfill":_vm.colors.discordfill,"discordcolor":_vm.colors.discordcolor},nativeOn:{"click":function($event){_vm.setPreviewType('standard')}}})],1),_vm._v(" "),_c('EyeSelector',{attrs:{"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"background":_vm.background,"custom-link":"#","is-rainbow":_vm.isRainbow,"discordfill":_vm.colors.discordfill,"discordcolor":_vm.colors.discordcolor},on:{"activeEyeChange":_vm.onActiveEyeChange}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('DiscordText',{ref:"discordtext",attrs:{"discord-eyes":_vm.discordEyes,"is-rainbow":_vm.isRainbow,"background":_vm.background,"custom-link":"#","animation-style":_vm.animationStyle,"standard-text":_vm.standardText,"discordfill":_vm.colors.discordfill,"discordcolor":_vm.colors.discordcolor},nativeOn:{"click":function($event){_vm.updateSpeechBubble() + _vm.setPreviewType('speechbubble')}}})],1),_vm._v(" "),_c('MainBody',{ref:"mainbody",attrs:{"background":_vm.background,"discord-eyes":_vm.discordEyes,"animation-style":_vm.animationStyle,"is-rainbow":_vm.isRainbow,"preview-discord-type":_vm.previewDiscordType}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("oAGa")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-js-toggle-button/dist/index.js
var vue_js_toggle_button_dist = __webpack_require__("nkUn");
var vue_js_toggle_button_dist_default = /*#__PURE__*/__webpack_require__.n(vue_js_toggle_button_dist);

// EXTERNAL MODULE: ./node_modules/portal-vue/dist/portal-vue.js
var portal_vue = __webpack_require__("9mpg");
var portal_vue_default = /*#__PURE__*/__webpack_require__.n(portal_vue);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["default"].use(vue_js_toggle_button_dist_default.a);
vue_esm["default"].use(portal_vue_default.a);
vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "QJtL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iVUo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "moOw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oAGa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sui6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xhcy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8fd13f073b2542889cb0.js